Object.defineProperty(exports, "__esModule", {
  value: true
});

var _airbnbPropTypes = require('airbnb-prop-types');

var _stringOrT = require('./stringOrT');

var _stringOrT2 = _interopRequireDefault(_stringOrT);

var _componentWithNamesOfHOCs = require('./componentWithNamesOfHOCs');

var _componentWithNamesOfHOCs2 = _interopRequireDefault(_componentWithNamesOfHOCs);

var _Text = require('../../exp/Text');

var _Text2 = _interopRequireDefault(_Text);

var _NewText = require('../../private/NewText');

var _NewText2 = _interopRequireDefault(_NewText);

var _PriceString = require('../../exp/PriceString');

var _PriceString2 = _interopRequireDefault(_PriceString);

var _LineBreaks = require('../../exp/LineBreaks');

var _LineBreaks2 = _interopRequireDefault(_LineBreaks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function makeRecursivePropType(propTypeThunk) {
  var propType = void 0;
  var propTypeGetter = function propTypeGetter() {
    if (!propType) {
      propType = propTypeThunk();
    }
    return propType.apply(undefined, arguments);
  };
  var propTypeRequiredGetter = function propTypeRequiredGetter() {
    var _propType;

    if (!propType) {
      propType = propTypeThunk();
    }
    return (_propType = propType).isRequired.apply(_propType, arguments);
  };
  propTypeGetter.isRequired = propTypeRequiredGetter;
  return propTypeGetter;
}

function getDefault(ModuleRecord) {
  return ModuleRecord['default'] || ModuleRecord;
}

exports['default'] = (0, _airbnbPropTypes.or)([_stringOrT2['default'], (0, _airbnbPropTypes.componentWithName)('Mario'), makeRecursivePropType(function () {
  // these shenanigans are because there's a circular reference between textlike & AccessibleText
  // eslint-disable-next-line global-require
  var AccessibleTextModule = require('../../exp/AccessibleText');
  return (0, _componentWithNamesOfHOCs2['default'])(getDefault(AccessibleTextModule), 'withStyles');
}), makeRecursivePropType(function () {
  // these shenanigans are because there's a circular reference between textlike & Labeled
  // eslint-disable-next-line global-require
  var LabeledModule = require('../../exp/Labeled');
  return (0, _componentWithNamesOfHOCs2['default'])(getDefault(LabeledModule), 'withStyles');
}), (0, _componentWithNamesOfHOCs2['default'])(_Text2['default'], 'withStyles'), (0, _componentWithNamesOfHOCs2['default'])(_PriceString2['default'], 'withStyles'), (0, _componentWithNamesOfHOCs2['default'])(_LineBreaks2['default'], 'withStyles'), (0, _componentWithNamesOfHOCs2['default'])(_NewText2['default'], 'withStyles')], 'textlike');


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/textlike.js
// module id = 24
// module chunks = 168707334958949